<template>
  <div class="long-time-box">
    <div class="div-block">
      <div class="div-txt">由于您长时间未访问，建议重新登录</div>
      <div class="div-input">
        <img src="@/assets/images/regist/img9.png" alt="" class="icon-label" />
        <input
          type="tel"
          inputmode="numeric"
          pattern="[0-9]{0,11}"
          :maxlength="11"
          placeholder="手机号"
          v-model="form.phone"
          class="input-val"
        />
      </div>
      <div class="div-input">
        <img src="@/assets/images/regist/img10.png" alt="" class="icon-label" />
        <input
          type="text"
          placeholder="请输入短信验证码"
          v-model="form.phoneCode"
          class="input-val"
        />
        <div class="code-btn" @click="handleSendCode">
          {{ counting ? `${count}秒后重新获取` : "发送验证码" }}
        </div>
      </div>
      <div class="btn" @click="handleSubmit">提交验证</div>
    </div>
  </div>
</template>
<script>
import { loginTimeoutVerifyPhone, sendPhoneMessageForLoginExpire } from '@/api/register'
import { saveCasesharingReturnFromBackurl } from '@/utils/util'
// import { beforeLoginFun } from '@/utils/util'
export default {
  data() {
    return {
      form: {
        iepOpenId: '',
        phone: '',
        phoneCode: '',
      },
      count: 60,
      counting: false,
      timer: null,
      endTime: null,
    }
  },
  mounted() {
    const iepLoginResult = JSON.parse(sessionStorage.getItem('iepLoginResult'))
    this.form.iepOpenId = iepLoginResult.openId
    this.form.phone = iepLoginResult.phone
    // 验证页还能读到 session 里的 backurl（提交时才删）。loginPage 若没写成 localStorage，这里再解一次
    saveCasesharingReturnFromBackurl(iepLoginResult)
    this.restoreCountdown()
  },
  methods: {
    startCountdown() {
      if (this.counting) return
      this.counting = true
      this.endTime = Date.now() + this.count * 1000
      localStorage.setItem('endTime', this.endTime)
      this.timer = setInterval(() => {
        this.updateCountdown()
      }, 1000)
    },
    updateCountdown() {
      const now = Date.now()
      if (now >= this.endTime) {
        this.resetCountdown()
      } else {
        this.count = Math.ceil((this.endTime - now) / 1000)
      }
    },
    resetCountdown() {
      clearInterval(this.timer)
      this.count = 60
      this.counting = false
      this.endTime = null
      localStorage.removeItem('endTime')
    },
    restoreCountdown() {
      const savedEndTime = localStorage.getItem('endTime')
      if (savedEndTime) {
        this.endTime = parseInt(savedEndTime, 10)
        this.counting = true
        this.updateCountdown()
        this.timer = setInterval(() => {
          this.updateCountdown()
        }, 1000)
      }
    },
    handleSendCode() {
      if (this.form.phone === '') {
        this.$toast('请填写手机号')
        return
      }
      sendPhoneMessageForLoginExpire({ phone: this.form.phone, openId: this.form.iepOpenId })
        .then((res) => {
          this.startCountdown()
        })
        .catch((err) => {
          this.$toast(err.msg)
          console.error(err)
        })
    },
    handleSubmit() {
      loginTimeoutVerifyPhone(this.form).then(res => {
        if (res.code === 0) {
          this.$toast(res.msg)
          sessionStorage.removeItem('iepLoginResult')

          // const { backurl } = iepLoginResult
          // if (backurl) {
          //   window.location.href = atob(backurl)
          //   return
          // }
          // if (!beforeLoginFun()) return
          // 病例社区 90 天：登录页已从 backurl.csReturn 写入，验证页 URL 上没有原链接
          const casesharingUrl = localStorage.getItem('casesharingRedirectURL')
          const bingliUrl = process.env.bingliUrl || ''
          if (casesharingUrl && bingliUrl && casesharingUrl.indexOf(bingliUrl) === 0) {
            localStorage.removeItem('casesharingRedirectURL')
            window.location.href = casesharingUrl
            return
          }
          const redirectURL = localStorage.getItem('redirectURL')
          if (redirectURL &&
              redirectURL.indexOf('/register') < 0 &&
              redirectURL.indexOf('/loginPage') < 0 &&
              redirectURL.indexOf('longTimeLogin') < 0) {
            const hrefTxt = redirectURL.indexOf('/journeymob') > -1
              ? redirectURL.substring(11)
              : redirectURL
            if (hrefTxt.indexOf('/') === 0 && hrefTxt.indexOf('http') !== 0) {
              localStorage.removeItem('redirectURL')
              // 90 天链路里 GetPermissionList 只写入了 permissionList，没有 addRoute。
              // pfa2 / technologyIndex 等是后台动态路由，此时 router.push 匹配不到组件会白屏，刷新才会走 permission 补路由。
              // 整页打开与刷新同一条链路；/home 仍走下面的 router.push（静态路由，不受影响）。
              const base = process.env.BASE_URL || ''
              window.location.replace(base + hrefTxt)
              return
            }
          }
          this.$router.push({
            path: '/home'
          })
        }
      }).catch((error) => {
        this.$toast(error.msg)
      })
    }
  }
}
</script>

<style scoped lang="less">
.long-time-box {
  width: 100%;
  height: 100%;
  background-color: #fff2e8;
  background-image: url("../../assets/images/regist/img11.png");
  background-repeat: no-repeat;
  background-size: 100%;

  .div-block {
    width: calc(100% - 24px);
    position: absolute;
    left: 12px;
    top: 38%;
    transform: translateY(-50%);
    height: 248px;
    background-color: #fff;
    border-radius: 12px;
    padding: 15px 12px 32px;
    box-sizing: border-box;
    .div-txt {
      text-align: center;
      font-family: PingFang HK, PingFang HK;
      font-size: 14px;
      color: #000000;
      line-height: 20px;
      margin-bottom: 15px;
    }
    .div-input {
      display: flex;
      align-items: center;
      height: 48px;
      margin-bottom: 15px;
      padding: 0 18px;
      box-sizing: border-box;
      .icon-label {
        width: 18px;
        margin-right: 8px;
        display: block;
      }
      .input-val {
        flex: 1;
        display: block;
        outline: none;
        border: none;
        background: transparent;
        height: 100%;
        font-family: Nunito, Nunito;
        color: #000;
        font-size: 14px;
        &::placeholder {
          color: rgba(0, 0, 0, 0.3);
        }
      }
      .code-btn {
        text-align: center;
        font-family: Nunito, Nunito;
        font-size: 14px;
        color: #eb1700;
      }
    }
  }

  .btn {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    font-size: 16px;
    color: #fff;
    border-radius: 100px;
    background: #EB1700;
    height: 42px;
    line-height: 42px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/loginPage/longTimeLogin.vue